import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  Paper,
  Grid,
  Tooltip,
  Typography,
  Grow,
} from '@material-ui/core';

import { Link } from 'react-router-dom';
import { truncate, prettifyDate } from '../../shared/Helpers';

const styles = theme => ({
  right: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingRight: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  listItem: {
    height: '169px',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    '&:hover': {
      transform: 'scale(1.05, 1.05)',
    },
  },
  category: {
    color: '#f44336',
    marginRight: theme.spacing(2),
    textTransform: 'uppercase',
    fontWeight: 'bold',
  },
  img: {
    height: 'auto',
    width: '300px',
    borderTopLeftRadius: '4px',
    borderBottomLeftRadius: '4px',
  },
  gridContainer: {
    width: '100%',
  },
  inlineFlex: {
    display: 'flex',
  },
  greyRule: {
    height: '1px',
    backgroundColor: 'lightgray',
    border: 'none',
  },
  title: {
    fontWeight: 'bold',
    fontSize: '1.3rem',
  },
});

const BlogPostList = ({ posts }) => (
  <div>
    {posts.map((post, index) => {
      const to = {
        pathname: `/blog/${post.url_slug || post.id}`,
        post,
      };
      return (
        <Link to={to} style={{ textDecoration: 'none' }} key={post.id}>
          <Grow appear in timeout={(400 * (index % 9))} style={{ transformOrigin: '0 0 0' }}>
            <div>
              <BlogPostListItem
                title={post.title}
                author={post.author.name}
                date={post.post_date}
                dateOverride={post.post_date_text_override}
                excerpt={post.excerpt}
                img={post.header_img}
                category={post.category.name}
              />
            </div>
          </Grow>
        </Link>
      );
    })}
  </div>
);

BlogPostList.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
};

let BlogPostListItem = ({
  title,
  author,
  date,
  dateOverride,
  excerpt,
  img,
  category,
  classes,
}) => (
  <Paper elevation={2} className={classes.listItem}>
    <Grid container className={classes.gridContainer}>
      <Grid item sm={5}>
        <img className={classes.img} src={`${img}`} alt={`Header for ${excerpt}`} />
      </Grid>
      <Grid item sm={7} className={classes.right}>
        <div>
          <Tooltip placement="top-start" title={title}>
            <Typography variant="h5" className={classes.title}>{truncate(title, 35)}</Typography>
          </Tooltip>
          <div className={classes.inlineFlex}>
            <Typography className={classes.category}>{category}</Typography>
            <Typography color="textSecondary">{dateOverride || prettifyDate(date)}</Typography>
          </div>
          <hr className={classes.greyRule} />
          <Typography>{truncate(excerpt, 100)}</Typography>
        </div>
        <Typography color="textSecondary" style={{ fontStyle: 'italic' }}>{`by ${author}`}</Typography>
      </Grid>
    </Grid>
  </Paper>
);

BlogPostListItem.defaultProps = {
  dateOverride: '',
};

BlogPostListItem.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string.isRequired).isRequired,
  title: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  dateOverride: PropTypes.string,
  excerpt: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
};

BlogPostListItem = withStyles(styles)(BlogPostListItem);

export default withStyles(styles)(BlogPostList);
